import 'COMMON';
import 'Vendor/polifill-object-fit-images/polifill-object-fit-images';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { eventSender } from 'Lib/event-sender/event-sender';
import { oLike } from 'Lib/like/like';
import 'Bem/site/calendar/calendar';
import 'Bem/site/radio/radio';
import 'Bem/site/subscribe-btn/subscribe-btn'; // удалить (возврат на верстку)
import 'Bem/journal/text-insert/text-insert';
import 'Bem/journal/gallery/gallery';
import 'Bem/journal/text-insert-card/text-insert-card';
import 'Bem/journal/article-t/article-t';
import 'Bem/journal/article-share/article-share';
import 'Bem/journal/text-insert-min/text-insert-min';
import 'Bem/site/copy/copy';
import 'Bem/site/journal-articles/journal-articles';
import { Reactions } from 'Lib/reactions/reactions';

const $body = $('body');
let reactions = new Reactions(document.querySelectorAll('.reactions'));

reactions.init();

$body.on('init.fastViewBook', () => {
    reactions = new Reactions(document.querySelectorAll('.reactions'));
    reactions.init();
});

svgSpriteLoader('/site/events/svg/sprite.svg?v=20180320');
oLike.init('.js-article-like');

$body.on('click', '.js-event-add-to-calendar', function () {
    const $this = $(this);
    const $parentlistItem = $this.closest('.event');
    const $parentDetail = $this.closest('.wrapper-content');
    let $name = $();

    if ($parentlistItem.length) {
        $name = $parentlistItem.find('.event__title').first();
    } else if ($parentDetail.length) {
        $name = $parentDetail.find('h1').first();
    }

    if ($name.length) {
        eventSender.customDL({
            event: 'eksmo',
            eventAction: 'engagement',
            eventCategory: 'Добавление мероприятия в Google календарь',
            eventLabel: $name.text().trim(),
        });
    }
});